var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgItem"},[_c('img',{class:{selected:_vm.selected},style:({
      width:_vm.width,
      height:_vm.height
    }),attrs:{"src":_vm.src,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }